import { useState, useRef, useEffect } from 'react';

export default function usePreloadImages(items = []) {
  const [done, setDone] = useState(false);
  const [current, setCurrent] = useState(0);
  const [total] = useState(items.length);
  const [loadedCurrent, setLoadedCurrent] = useState(false);

  const image = useRef(null);

  useEffect(() => {
    if (items[current]) {
      const srcset = items[current].srcset
        ? items[current].srcset
        : items[current].images
            .map((image) => `${image.url} ${image.width}w`)
            .join(', ');
      const sizes = items[current].sizes
        ? items[current].sizes.join(', ')
        : '100vw';
      image.current = new Image();
      image.current.onload = () => {
        setLoadedCurrent(true);
      };
      image.current.sizes = sizes;
      image.current.srcset = srcset;
    } else {
      setLoadedCurrent(true);
    }
  }, [current]);

  useEffect(() => {
    if (loadedCurrent) {
      image.current = null;
      const nextCurrent = current + 1;
      if (nextCurrent < total) {
        setCurrent(nextCurrent);
        setLoadedCurrent(false);
      } else {
        setDone(true);
      }
    }
  }, [current, loadedCurrent]);

  const state = {
    done,
    current,
    total,
  };

  return state;
}
